@if (isAppInitialized) {
    @if (isSystemAdmin) {
        <div class="system-admin-denied-wrapper" style="height: 100%">
            <app-top-menu></app-top-menu>
            <sb-access-denied-page></sb-access-denied-page>
        </div>
    } @else {
        <div [ngClass]="{ 'onetime-block': isOneTime }" style="height: 100%">
            <router-outlet></router-outlet>
        </div>
    }
}

<simple-notifications></simple-notifications>
@if (isRefOnboarding) {
    <app-onboarding-landing-modal [isModalShown]="isRefOnboarding"></app-onboarding-landing-modal>
}

<!-- preloader for emoji image -->
<img [src]="'sb-tools/theme/images/emojis/apple_32.png?v=3'" hidden />
